import React, { useState } from 'react';
import { View, Text, TouchableOpacity, Modal, Image, StyleSheet } from 'react-native';
import CloseButtonImage from '../../../../assets/svg/x-button.svg';
import externalLink from '../../../../assets/img/external-link.svg';
import personIcon from '../../../../assets/svg/person-icon.svg';
import emailIcon from '../../../../assets/svg/email-icon.svg';
import phoneIcon from '../../../../assets/svg/phone-icon.svg';
import Actions from '../../../../RouteActions';
import FloatingLabelInput from './FloatingLabelInput';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './CandidateInfoModal.css' 

const CandidateInfoModal = ({ showModal, setShowModal, organization, jobTitle, onSubmit }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone_number: '',
  });

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (key, value) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };

  const isFormValid =
    formData.firstName.trim() !== '' &&
    formData.lastName.trim() !== '' &&
    formData.phone_number.trim() !== '' &&
    validateEmail(formData.email)

  const handleContinue = () => {
    if (isFormValid) {
      onSubmit(formData);
      setShowModal(false);
    }
  };

  return (
    <Modal transparent={true} visible={showModal} onRequestClose={() => setShowModal(false)}>
      <View style={styles.overlay}>
        <View style={styles.modalContainer}>
          <View style={styles.header}>
            <Text style={styles.headerText}>Let's Get You Started</Text>
            <TouchableOpacity onPress={() => setShowModal(false)}>
              <Image source={CloseButtonImage} style={{ width: 20, height: 20 }} />
            </TouchableOpacity>
          </View>

          <View style={styles.content}>
            <Text style={{ fontWeight: 'bold', marginBottom: 15 }}>THANKS FOR YOUR INTEREST!</Text>
            <Text style={{ textAlign: 'left', marginBottom: 15 }}>
              We're excited about your interest in the {jobTitle} position at {organization}.
              Please fill out the following information to begin your application process.
            </Text>

            <FloatingLabelInput label="*First Name" value={formData.firstName} onChangeText={value => handleChange('firstName', value)} icon={personIcon} iconStyle={{width: 20, height: 20}} />
            <FloatingLabelInput label="*Last Name" value={formData.lastName} onChangeText={value => handleChange('lastName', value)} icon={personIcon} iconStyle={{width: 20, height: 20}} />
            <FloatingLabelInput 
              label="*Email Address" 
              value={formData.email} 
              onChangeText={value => handleChange('email', value)} 
              keyboardType="email-address" 
              icon={emailIcon} 
              iconStyle={{width: 20, height: 15}}
            />
            <View style={styles.inputWrapper}>
              <Text style={styles.floatingLabel}>Phone Number*</Text>
              <View style={styles.phoneInputContainer}>
                <PhoneInput
                  value={formData.phone_number}
                  country="us"
                  onChange={phone_number => handleChange('phone_number', phone_number.length > 0 && phone_number[0] !== '+' ? '+' + phone_number : phone_number)}
                  inputStyle={styles.phoneInput}
                  containerStyle={styles.phoneInputContainerStyle}
                  dropdownStyle={styles.dropDown}
                />
                <Image source={phoneIcon} style={styles.phoneIcon} />
              </View>
            </View>

            <TouchableOpacity onPress={handleContinue} style={[styles.button, !isFormValid && styles.disabledButton]} 
              disabled={!isFormValid}>
              <Text style={{ color: 'white' }}>Continue Application</Text>
              <Image source={externalLink} style={styles.buttonIcon} />
            </TouchableOpacity>

            <Text style={styles.footerText}>You'll be redirected to complete your application on the {organization} careers portal.</Text>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = {
  overlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#E7E7E796',
  },
  modalContainer: {
    backgroundColor: 'white',
    width: 475,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  header: {
    backgroundColor: '#F4F5F8',
    padding: 15,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerText: {
    fontWeight: 'bold',
    fontSize: 16,
  },
  content: {
    paddingTop: 25,
    paddingBottom: 25,
    paddingLeft: 80,
    paddingRight: 80,
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#28a745',
    padding: 18,
    borderRadius: 5,
    marginTop: 10,
    zIndex: -1
  },
  footerText: {
    color: '#5D5D5D',
    marginTop: 10,
    fontSize: 12,
  },
  inputWrapper: {
    marginBottom: 20,
    position: 'relative',
  },
  floatingLabel: {
    position: 'absolute',
    left: 12,
    top: -10,
    backgroundColor: 'white',
    paddingHorizontal: 5,
    fontSize: 12,
    color: '#888',
    zIndex: 10,
  },
  phoneInputContainer: {
    position: 'relative',
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'white',
  },
  dropDown: {
    padding: 0
  },
  phoneInput: {
    fontSize: 16,
    border: 'none',
    width: '100%',
    height: 45,
  },
  phoneInputContainerStyle: {
    borderWidth: 0,

  },
  phoneIcon: {
    position: 'absolute',
    right: 10,
    height: 25,
    width: 25,
  },
  country: {
    padding: '7px 40px'
  },
  disabledButton: {
    backgroundColor: '#ccc',
  },
  buttonIcon: {
    width: 12,
    height: 15,
    marginLeft: 5,
  },
  errorText: {
    color: 'red',
    fontSize: 12,
    marginTop: 5,
  },
};

export default CandidateInfoModal;
